import { signal } from '@preact/signals';
import { db, getCachedProfile } from '@/lib/db';
import type { Animal, Schedule, FeedLog, Timer, Profile } from '@/types';

/** In-memory mirrors of the Dexie cache. Screens read these signals;
 *  mutations.ts and sync.ts call reloadFromCache() after writing Dexie. */

export const animals = signal<Map<string, Animal>>(new Map());
export const schedules = signal<Map<string, Schedule>>(new Map());
export const openTimers = signal<Timer[]>([]);
export const recentLogs = signal<FeedLog[]>([]);
export const profile = signal<Profile | null>(null);
export const dataReady = signal(false);

/** Minute-ish tick that drives countdown re-renders. */
export const nowTick = signal(Date.now());
setInterval(() => (nowTick.value = Date.now()), 30_000);

export async function reloadFromCache() {
  const [a, s, t, l, p] = await Promise.all([
    db.animals.toArray(),
    db.schedules.toArray(),
    db.timers.filter((x) => !x.completed_at && !x.canceled_at).toArray(),
    db.feed_logs.orderBy('fed_at').reverse().limit(400).toArray(),
    getCachedProfile(),
  ]);
  animals.value = new Map(a.map((x) => [x.id, x]));
  schedules.value = new Map(s.map((x) => [x.id, x]));
  openTimers.value = t.sort((x, y) => x.due_at.localeCompare(y.due_at));
  recentLogs.value = l;
  profile.value = p;
  dataReady.value = true;
}
